unit PrjFormSeminarKenndaten;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  PrjFormDefault,
  Vcl.Graphics,
  Vcl.StdCtrls,
  Vcl.Controls,
  WEBLib.StdCtrls,
  WEBLib.ExtCtrls,
  PrjClassHBMDataAccess,
  Vcl.Imaging.GIFImg,
  WEBLib.CheckLst, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client, XData.Web.Connection, WEBLib.Grids, Vcl.Grids, WEBLib.DBCtrls;

type
  TPrjFormsSeminarKenndaten = class(TPrjFormsDefault)
    pnSeminarKennDaten: TPanel;
    lblStation1: TLabel;
    WebLabel1: TLabel;
    pnLeftNavigation: TPanel;
    lblPeriode: TLabel;
    btnClose: TButton;
    btnSave: TButton;
    spedPeriode: TSpinEdit;
    btnPrint: TButton;
    btnCancel: TButton;
    brnHelp: TButton;
    chkgbSeminarKenndaten: TCheckListBox;
    WebLabel2: TLabel;
    XDataWebConnection1: TXDataWebConnection;
    XDataWebDataSetKenndaten: TXDataWebDataSet;
    KenndatenDataSource: TDataSource;
    webEdtSeminarName: TDBEdit;
    spedAnzKH: TDBSpinEdit;
    memEmailList: TDBMemo;
    procedure btnCancelClick(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
    procedure XDataWebDataSetKenndatenAfterOpen(DataSet: TDataSet);
  strict private
    FInitialising : boolean;
    [Async]
    procedure ToggleGUI; async;
  private
    [Async]
    function SaveData: Boolean; async;

    [Async]
    function TransferData: Boolean; async;
    [Async]
    function TransferDescisions: Boolean; async; virtual;

    { Private-Deklarationen }
  strict protected
  public
    [Async]
    function Init: Boolean; async; override;
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  PrjFormsSeminarKenndaten: TPrjFormsSeminarKenndaten;

implementation

{$R *.dfm}

uses
  System.DateUtils,
  PrjFormMain,
  HBMWebData,
  wxBaseClassWebTools;

procedure TPrjFormsSeminarKenndaten.btnCancelClick(Sender: TObject);
begin
  XDataWebDataSetKenndaten.Cancel;
  close;
end;

procedure TPrjFormsSeminarKenndaten.btnCloseClick(Sender: TObject);
begin
  //TransferData;
  Self.SaveData;
  close;
end;

function TPrjFormsSeminarKenndaten.Init: Boolean;
begin
  FInitialising := true;

  spedAnzKH.Enabled             := false;
  chkgbSeminarKenndaten.Enabled := false;
  btnClose.Enabled              := false;


  XDataWebDataSetKenndaten.Connection   := PrjFormsMain.XDataWebConnectionMain;
  XDataWebDataSetKenndaten.QueryString  := '$filter=(Mudf_User_Id eq ' + DataModule.TokenInformation.UserID.ToString + ')' ;
  XDataWebDataSetKenndaten.Load;

  chkgbSeminarKenndaten.Items.clear;
  chkgbSeminarKenndaten.Items.add('Entscheidungen von KH 1 auf all anderen kopieren');

  spedAnzKH.MinValue      := 1;
  spedAnzKH.MaxValue      := 5;

  // Änderungen hier nur wenn die Periode noch Null ist
  spedAnzKH.Enabled       := DataModule.TokenInformation.PeriodId = 0;
  chkgbSeminarKenndaten.Enabled := DataModule.TokenInformation.PeriodId = 0;

  spedPeriode.enabled     := false;
end;

function TPrjFormsSeminarKenndaten.SaveData: Boolean;
begin
  Result := true;
  Result := await(TransferData);
  Result := Result and await(TransferDescisions);
end;

procedure TPrjFormsSeminarKenndaten.ToggleGUI;
begin
  if spedPeriode.Value > 0 then
  begin
    spedAnzKH.Enabled             := false;
    chkgbSeminarKenndaten.Enabled := false;
  end else
  begin
    spedAnzKH.Enabled             := true;
    chkgbSeminarKenndaten.Enabled := true;
  end;
  if not FInitialising then
    btnClose.Enabled := true;
end;

function TPrjFormsSeminarKenndaten.TransferData: Boolean;
begin
  Result := true;
  try
    if XDataWebDataSetKenndaten.State in [dsEdit] then
    begin

      if chkgbSeminarKenndaten.Items.Count > 0 then
      begin
        if chkgbSeminarKenndaten.Checked[0] then
          XDataWebDataSetKenndaten.FieldByName('Mudf_Descision_Copy').AsInteger := 1
        else
          XDataWebDataSetKenndaten.FieldByName('Mudf_Descision_Copy').AsInteger := 0;
      end;

      XDataWebDataSetKenndaten.FieldByName('MUDF_MAX_ANZ_UNTERNEHMEN').AsInteger := spedAnzKH.Value;

      XDataWebDataSetKenndaten.Post;
      XDataWebDataSetKenndaten.ApplyUpdates;
    end else
    begin
      wxBaseWriteLog.Write('Exception XDataWebDataSetKenndaten not in edit mode', slDebug);
      result := false;
    end;
  except
    wxBaseWriteLog.Write('Exception raised in modul TPrjFormsSeminarKenndaten.TransferData', slDebug);
    Result := false;
  end;
end;

procedure TPrjFormsSeminarKenndaten.XDataWebDataSetKenndatenAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetKenndaten.IsEmpty then
  begin
    XDataWebDataSetKenndaten.Edit;
    FInitialising := false;
    Self.ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetKenndaten.EntitySetName + ']', slDebug);
  end;
end;

function TPrjFormsSeminarKenndaten.TransferDescisions: Boolean;
begin
  if not await(DataAccess.RequestDaten('Z', PrjFormsMain.XDataWebConnectionMain)) then
  begin
    wxBaseWriteLog.Write('await(PrjFormsSeminarKenndaten.TransferDescisions was not successful', slError);
  end;
end;

procedure TPrjFormsSeminarKenndaten.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnSeminarKennDaten := TPanel.Create('pnSeminarKenndaten');
  lblStation1 := TLabel.Create('nameSeminarLabel');
  WebLabel1 := TLabel.Create('anzahlLabel');
  WebLabel2 := TLabel.Create('EmailAdrListeLabel');
  chkgbSeminarKenndaten := TCheckListBox.Create('chkgbSeminarKenndaten');
  webEdtSeminarName := TDBEdit.Create('nameSeminarInput');
  spedAnzKH := TDBSpinEdit.Create('anzahlInput');
  memEmailList := TDBMemo.Create('EmailAdrListeTextarea');
  pnLeftNavigation := TPanel.Create('PanelNAVDefault');
  lblPeriode := TLabel.Create('LabelNAVPeriode');
  btnClose := TButton.Create('btnNAVBack');
  btnSave := TButton.Create('btnNAVSave');
  spedPeriode := TSpinEdit.Create('SpinEdNAVPeriode');
  btnPrint := TButton.Create('btnNAVPrint');
  btnCancel := TButton.Create('btnNAVCancel');
  brnHelp := TButton.Create('btnNAVHelp');
  XDataWebConnection1 := TXDataWebConnection.Create(Self);
  XDataWebDataSetKenndaten := TXDataWebDataSet.Create(Self);
  KenndatenDataSource := TDataSource.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  pnSeminarKennDaten.BeforeLoadDFMValues;
  lblStation1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  chkgbSeminarKenndaten.BeforeLoadDFMValues;
  webEdtSeminarName.BeforeLoadDFMValues;
  spedAnzKH.BeforeLoadDFMValues;
  memEmailList.BeforeLoadDFMValues;
  pnLeftNavigation.BeforeLoadDFMValues;
  lblPeriode.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  spedPeriode.BeforeLoadDFMValues;
  btnPrint.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  brnHelp.BeforeLoadDFMValues;
  XDataWebConnection1.BeforeLoadDFMValues;
  XDataWebDataSetKenndaten.BeforeLoadDFMValues;
  KenndatenDataSource.BeforeLoadDFMValues;
  try
    Width := 1112;
    Height := 833;
    ElementClassName := '!w-full !h-full !flex !justify-center !items-center !top-0 !left-0 bg-[#0008]';
    WaitMessage.Picture.LoadFromFile('PrjFormSeminarKenndaten.WaitMessage.Picture.gif');
    pnSeminarKennDaten.SetParentComponent(Self);
    pnSeminarKennDaten.Name := 'pnSeminarKennDaten';
    pnSeminarKennDaten.Left := 0;
    pnSeminarKennDaten.Top := 0;
    pnSeminarKennDaten.Width := 840;
    pnSeminarKennDaten.Height := 833;
    pnSeminarKennDaten.Align := alClient;
    pnSeminarKennDaten.TabOrder := 1;
    lblStation1.SetParentComponent(pnSeminarKennDaten);
    lblStation1.Name := 'lblStation1';
    lblStation1.Left := 16;
    lblStation1.Top := 88;
    lblStation1.Width := 235;
    lblStation1.Height := 29;
    lblStation1.Caption := 'Name des Seminars';
    lblStation1.Font.Charset := DEFAULT_CHARSET;
    lblStation1.Font.Color := clWindowText;
    lblStation1.Font.Height := -24;
    lblStation1.Font.Name := 'Tahoma';
    lblStation1.Font.Style := [fsBold];
    lblStation1.HeightPercent := 100.00000000000000000;
    lblStation1.ParentFont := False;
    lblStation1.WidthPercent := 100.00000000000000000;
    WebLabel1.SetParentComponent(pnSeminarKennDaten);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 152;
    WebLabel1.Width := 447;
    WebLabel1.Height := 29;
    WebLabel1.Caption := 'Anzahl der beteiligten Krankenh'#228'user';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -24;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.00000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.00000000000000000;
    WebLabel2.SetParentComponent(pnSeminarKennDaten);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 48;
    WebLabel2.Top := 224;
    WebLabel2.Width := 357;
    WebLabel2.Height := 29;
    WebLabel2.Caption := 'Liste der Passwort Empf'#228'nger';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -24;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.00000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.00000000000000000;
    chkgbSeminarKenndaten.SetParentComponent(pnSeminarKennDaten);
    chkgbSeminarKenndaten.Name := 'chkgbSeminarKenndaten';
    chkgbSeminarKenndaten.Left := 48;
    chkgbSeminarKenndaten.Top := 514;
    chkgbSeminarKenndaten.Width := 705;
    chkgbSeminarKenndaten.Height := 225;
    chkgbSeminarKenndaten.ElementCheckClassName := 'me-2 checkbox';
    chkgbSeminarKenndaten.ElementItemClassName := 'form-check';
    chkgbSeminarKenndaten.ElementFont := efCSS;
    chkgbSeminarKenndaten.HeightPercent := 100.00000000000000000;
    chkgbSeminarKenndaten.ItemHeight := 18;
    chkgbSeminarKenndaten.WidthPercent := 100.00000000000000000;
    webEdtSeminarName.SetParentComponent(pnSeminarKennDaten);
    webEdtSeminarName.Name := 'webEdtSeminarName';
    webEdtSeminarName.Left := 504;
    webEdtSeminarName.Top := 80;
    webEdtSeminarName.Width := 257;
    webEdtSeminarName.Height := 53;
    webEdtSeminarName.ChildOrder := 7;
    webEdtSeminarName.ElementFont := efCSS;
    webEdtSeminarName.HeightPercent := 100.00000000000000000;
    webEdtSeminarName.Text := 'webEdtSeminarName';
    webEdtSeminarName.WidthPercent := 100.00000000000000000;
    webEdtSeminarName.DataField := 'Mudf_Seminar_Name';
    webEdtSeminarName.DataSource := KenndatenDataSource;
    spedAnzKH.SetParentComponent(pnSeminarKennDaten);
    spedAnzKH.Name := 'spedAnzKH';
    spedAnzKH.Left := 504;
    spedAnzKH.Top := 152;
    spedAnzKH.Width := 257;
    spedAnzKH.Height := 58;
    spedAnzKH.HeightStyle := ssAuto;
    spedAnzKH.AutoSize := False;
    spedAnzKH.BorderStyle := bsSingle;
    spedAnzKH.ChildOrder := 7;
    spedAnzKH.Color := clWhite;
    spedAnzKH.ElementFont := efCSS;
    spedAnzKH.Increment := 1;
    spedAnzKH.MaxValue := 5;
    spedAnzKH.MinValue := 1;
    spedAnzKH.Role := '';
    spedAnzKH.Value := 0;
    spedAnzKH.DataField := 'Mudf_Max_Anz_Unternehmen';
    spedAnzKH.DataSource := KenndatenDataSource;
    memEmailList.SetParentComponent(pnSeminarKennDaten);
    memEmailList.Name := 'memEmailList';
    memEmailList.Left := 48;
    memEmailList.Top := 272;
    memEmailList.Width := 705;
    memEmailList.Height := 225;
    memEmailList.Hint := 'Bitte EMail Adressen mit Semiklon getrennt eingeben';
    memEmailList.ElementFont := efCSS;
    memEmailList.HeightPercent := 100.00000000000000000;
    memEmailList.Lines.BeginUpdate;
    try
      memEmailList.Lines.Clear;
      memEmailList.Lines.Add('memEmailList');
    finally
      memEmailList.Lines.EndUpdate;
    end;
    memEmailList.SelLength := 0;
    memEmailList.SelStart := 0;
    memEmailList.ShowHint := True;
    memEmailList.WidthPercent := 100.00000000000000000;
    memEmailList.DataField := 'Mudf_Email_List';
    memEmailList.DataSource := KenndatenDataSource;
    pnLeftNavigation.SetParentComponent(Self);
    pnLeftNavigation.Name := 'pnLeftNavigation';
    pnLeftNavigation.Left := 840;
    pnLeftNavigation.Top := 0;
    pnLeftNavigation.Width := 272;
    pnLeftNavigation.Height := 833;
    pnLeftNavigation.HeightStyle := ssAuto;
    pnLeftNavigation.WidthStyle := ssAuto;
    pnLeftNavigation.Align := alRight;
    pnLeftNavigation.Alignment := taLeftJustify;
    pnLeftNavigation.Caption := 'pnLeftNavigation';
    pnLeftNavigation.ChildOrder := 2;
    pnLeftNavigation.ElementFont := efCSS;
    pnLeftNavigation.ElementPosition := epRelative;
    pnLeftNavigation.ShowCaption := False;
    pnLeftNavigation.TabOrder := 2;
    lblPeriode.SetParentComponent(pnLeftNavigation);
    lblPeriode.Name := 'lblPeriode';
    lblPeriode.Left := 17;
    lblPeriode.Top := 240;
    lblPeriode.Width := 165;
    lblPeriode.Height := 29;
    lblPeriode.Caption := 'Gesch'#228'ftsjahr';
    lblPeriode.ElementFont := efCSS;
    lblPeriode.ElementPosition := epRelative;
    lblPeriode.Font.Charset := DEFAULT_CHARSET;
    lblPeriode.Font.Color := clWindowText;
    lblPeriode.Font.Height := -24;
    lblPeriode.Font.Name := 'Tahoma';
    lblPeriode.Font.Style := [fsBold];
    lblPeriode.HeightStyle := ssAuto;
    lblPeriode.HeightPercent := 100.00000000000000000;
    lblPeriode.ParentFont := False;
    lblPeriode.WidthStyle := ssAuto;
    lblPeriode.WidthPercent := 100.00000000000000000;
    btnClose.SetParentComponent(pnLeftNavigation);
    btnClose.Name := 'btnClose';
    btnClose.Left := 19;
    btnClose.Top := 35;
    btnClose.Width := 250;
    btnClose.Height := 55;
    btnClose.Caption := 'Start';
    btnClose.ChildOrder := 7;
    btnClose.ElementClassName := 'btn btn-outline';
    btnClose.ElementFont := efCSS;
    btnClose.ElementPosition := epRelative;
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.00000000000000000;
    btnClose.WidthStyle := ssAuto;
    btnClose.WidthPercent := 100.00000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnSave.SetParentComponent(pnLeftNavigation);
    btnSave.Name := 'btnSave';
    btnSave.Left := 13;
    btnSave.Top := 116;
    btnSave.Width := 250;
    btnSave.Height := 55;
    btnSave.Caption := 'Speichern';
    btnSave.ChildOrder := 7;
    btnSave.ElementClassName := 'btn btn-success btn-outline';
    btnSave.ElementFont := efCSS;
    btnSave.ElementPosition := epRelative;
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.00000000000000000;
    btnSave.Visible := False;
    btnSave.WidthStyle := ssAuto;
    btnSave.WidthPercent := 100.00000000000000000;
    spedPeriode.SetParentComponent(pnLeftNavigation);
    spedPeriode.Name := 'spedPeriode';
    spedPeriode.Left := 14;
    spedPeriode.Top := 275;
    spedPeriode.Width := 250;
    spedPeriode.Height := 57;
    spedPeriode.ElementClassName := 'input input-bordered';
    spedPeriode.HeightStyle := ssAuto;
    spedPeriode.WidthStyle := ssAuto;
    spedPeriode.AutoSize := False;
    spedPeriode.BorderStyle := bsSingle;
    spedPeriode.ChildOrder := 7;
    spedPeriode.Color := clWhite;
    spedPeriode.ElementFont := efCSS;
    spedPeriode.ElementPosition := epRelative;
    spedPeriode.Increment := 1;
    spedPeriode.MaxValue := 100;
    spedPeriode.MinValue := 0;
    spedPeriode.Role := '';
    spedPeriode.Value := 0;
    btnPrint.SetParentComponent(pnLeftNavigation);
    btnPrint.Name := 'btnPrint';
    btnPrint.Left := 13;
    btnPrint.Top := 499;
    btnPrint.Width := 250;
    btnPrint.Height := 55;
    btnPrint.Caption := 'Drucken';
    btnPrint.ChildOrder := 7;
    btnPrint.ElementClassName := 'btn border btn-outline btn-accent';
    btnPrint.ElementFont := efCSS;
    btnPrint.ElementPosition := epRelative;
    btnPrint.HeightStyle := ssAuto;
    btnPrint.HeightPercent := 100.00000000000000000;
    btnPrint.Visible := False;
    btnPrint.WidthStyle := ssAuto;
    btnPrint.WidthPercent := 100.00000000000000000;
    btnCancel.SetParentComponent(pnLeftNavigation);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 13;
    btnCancel.Top := 594;
    btnCancel.Width := 250;
    btnCancel.Height := 55;
    btnCancel.Caption := 'Abbruch';
    btnCancel.ChildOrder := 7;
    btnCancel.ElementClassName := 'btn btn-error';
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epRelative;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.00000000000000000;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.00000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    brnHelp.SetParentComponent(pnLeftNavigation);
    brnHelp.Name := 'brnHelp';
    brnHelp.Left := 13;
    brnHelp.Top := 684;
    brnHelp.Width := 250;
    brnHelp.Height := 55;
    brnHelp.Caption := 'Hilfe';
    brnHelp.ChildOrder := 7;
    brnHelp.ElementClassName := 'btn btn-info';
    brnHelp.ElementFont := efCSS;
    brnHelp.ElementPosition := epRelative;
    brnHelp.HeightStyle := ssAuto;
    brnHelp.HeightPercent := 100.00000000000000000;
    brnHelp.Visible := False;
    brnHelp.WidthStyle := ssAuto;
    brnHelp.WidthPercent := 100.00000000000000000;
    XDataWebConnection1.SetParentComponent(Self);
    XDataWebConnection1.Name := 'XDataWebConnection1';
    XDataWebConnection1.URL := 'https://hbm-online.eu/MFCWebServices/';
    XDataWebConnection1.Connected := True;
    XDataWebConnection1.Left := 489;
    XDataWebConnection1.Top := 360;
    XDataWebDataSetKenndaten.SetParentComponent(Self);
    XDataWebDataSetKenndaten.Name := 'XDataWebDataSetKenndaten';
    XDataWebDataSetKenndaten.AfterOpen := XDataWebDataSetKenndatenAfterOpen;
    XDataWebDataSetKenndaten.EntitySetName := 'Tblwx_User_Defaults';
    XDataWebDataSetKenndaten.Connection := XDataWebConnection1;
    XDataWebDataSetKenndaten.Left := 169;
    XDataWebDataSetKenndaten.Top := 336;
    KenndatenDataSource.SetParentComponent(Self);
    KenndatenDataSource.Name := 'KenndatenDataSource';
    KenndatenDataSource.DataSet := XDataWebDataSetKenndaten;
    KenndatenDataSource.Left := 169;
    KenndatenDataSource.Top := 408;
  finally
    WaitMessage.AfterLoadDFMValues;
    pnSeminarKennDaten.AfterLoadDFMValues;
    lblStation1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    chkgbSeminarKenndaten.AfterLoadDFMValues;
    webEdtSeminarName.AfterLoadDFMValues;
    spedAnzKH.AfterLoadDFMValues;
    memEmailList.AfterLoadDFMValues;
    pnLeftNavigation.AfterLoadDFMValues;
    lblPeriode.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    spedPeriode.AfterLoadDFMValues;
    btnPrint.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    brnHelp.AfterLoadDFMValues;
    XDataWebConnection1.AfterLoadDFMValues;
    XDataWebDataSetKenndaten.AfterLoadDFMValues;
    KenndatenDataSource.AfterLoadDFMValues;
  end;
end;

end.
